// views/informs/IndividualInformView.js
import React, { useEffect, useState } from 'react';
import './IndividualInformView.css';
import '../InformView.css';
import axios from 'axios';
import { Button, Spin } from 'antd';
import { useParams } from 'react-router-dom';

import { apiUrl } from '../../../utility/Connections';
import LeadershipIndividual from '../../../components/informs/leadershipIndividual/leadershipIndividual';
import Selfcare360Individual from '../../../components/informs/selfcare360Individual/selfcare360Individual';
import SelfcareIndividual from '../../../components/informs/selfcareIndividual/selfcareIndividual';

const IndividualInformView = () => {
    const { evl_id, dni } = useParams();
    const [showLoading, setShowLoading] = useState(true);

    const [selectedEvaluation, setSelectedEvaluation] = useState(null);

    const [totalResults, setTotalResults] = useState({});
    const [individualResult, setIndividualResult] = useState([]);

    const [orgLogo, setOrgLogo] = useState(null);
    const [orgName, setOrgName] = useState(null);

    useEffect(() => {
        getEvaluation(evl_id);
    }, [evl_id]);

    const getEvaluation = (evl_id) => {
        setShowLoading(true);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/evaluations/get-evaluation-info-by-id/${evl_id}/`, headers)
            .then(function (response) {
                const data = response.data;
                setSelectedEvaluation(data);
                getEvaluationResults(data.evl_id, data.evl_org_id);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getEvaluationResults = async (evl_id, org_id) => {
        setShowLoading(true);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/informs/get-evaluation-results-individual/${evl_id}/${dni}/`, headers)
            .then(function (response) {
                const data = response.data;
                setTotalResults(data.totals);
                setIndividualResult(data.result);
                getOrganizationLogo(org_id);
                getOrganizationName(org_id);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const getOrganizationName = (orgId) => {
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        };

        axios.get(`${apiUrl}/organizations/get-organization-by-id/${orgId}/`, headers)
            .then(function (response) {
                setOrgName(response.data?.org_name || null);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
            });
    };

    const getOrganizationLogo = (orgId) => {
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    if (showLoading) {
        return (
            <div className="display-center-row display-center-column align-full-center" style={{ height: '100vh' }}>
                <Spin size="large" tip="Cargando informe..." />
            </div>
        );
    }

    if (!totalResults) {
        return <div>Error al cargar la información del informe.</div>;
    }

    if (selectedEvaluation?.evl_srv_id === 7) {
        const rels = individualResult?.relationships_by_type || {};
        let countJefe = 0;
        let countColab = 0;
        let countPar = 0;
        let countCliente = 0;
        let countAuto = 0;
        let totalN = 0;

        Object.entries(rels).forEach(([key, count]) => {
            const k = key.toLowerCase();
            totalN += count;
            if (k.includes('jefe') || k.includes('líder') || k.includes('lider')) countJefe += count;
            if (k.includes('colab')) countColab += count;
            if (k.includes('par')) countPar += count;
            if (k.includes('cliente') || k.includes('interno')) countCliente += count;
            if (k.includes('auto')) countAuto += count;
        });

        // Regla: mínimo 5 evaluadores en total; obligatorios: 1 jefe + 1 auto.
        // El resto (≥ 3) puede ser cualquier combinación de colaboradores, pares o clientes internos.
        const countOthers = countColab + countPar + countCliente;
        if (totalN < 5 || countJefe < 1 || countAuto < 1) {
            return (
                <div className="display-center-row display-center-column align-full-center" style={{ height: '100vh', backgroundColor: '#f5f7fa', padding: '20px' }}>
                    <div style={{ textAlign: 'center', padding: '40px', backgroundColor: 'white', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', maxWidth: '600px' }}>
                        <h2 style={{ color: '#e53935', marginTop: 0 }}>Reporte Bloqueado</h2>
                        <p style={{ fontSize: '18px', color: '#555', marginBottom: '20px' }}>
                            Muestra insuficiente — se requieren mínimo 5 evaluadores en total: 1 jefe inmediato, 1 autoevaluación y al menos 3 entre colaboradores, pares o clientes internos.
                        </p>
                        <div style={{ backgroundColor: '#fafafa', padding: '15px', borderRadius: '8px', display: 'inline-block', textAlign: 'left', border: '1px solid #eee' }}>
                            <ul style={{ margin: 0, paddingLeft: '20px', color: '#444' }}>
                                <li style={{ marginBottom: '8px' }}><b>Total evaluadores ({totalN}):</b> {totalN >= 5 ? '✅' : '❌ (Mínimo 5)'}</li>
                                <li style={{ marginBottom: '8px' }}><b>Autoevaluación ({countAuto}):</b> {countAuto >= 1 ? '✅' : '❌ (Mínimo 1)'}</li>
                                <li style={{ marginBottom: '8px' }}><b>Jefe Inmediato ({countJefe}):</b> {countJefe >= 1 ? '✅' : '❌ (Mínimo 1)'}</li>
                                <li><b>Colaboradores / Pares / Cliente interno ({countOthers}):</b> {countOthers >= 3 ? '✅' : '❌ (Mínimo 3 entre estas categorías)'}</li>
                            </ul>
                        </div>
                        <div style={{ marginTop: '24px' }}>
                            <Button danger type="primary" onClick={() => window.close()}>
                                Cerrar pestaña
                            </Button>
                        </div>
                    </div>
                </div>
            );
        }
    }

    return (
        <div className="informe-wrapper">
            {selectedEvaluation?.evl_srv_id === 7 ? (
                <Selfcare360Individual
                    totalResults={totalResults}
                    individualResult={individualResult}
                    selectedEvaluation={selectedEvaluation}
                    orgLogo={orgLogo}
                    orgName={orgName}
                />
            ) : selectedEvaluation?.evl_srv_id === 6 ? (
                <SelfcareIndividual
                    totalResults={totalResults}
                    individualResult={individualResult}
                    selectedEvaluation={selectedEvaluation}
                    orgLogo={orgLogo}
                />
            ) : (
                <LeadershipIndividual
                    totalResults={totalResults}
                    individualResult={individualResult}
                    selectedEvaluation={selectedEvaluation}
                    orgLogo={orgLogo}
                />
            )}
        </div>
    );
};

export default IndividualInformView;
